module.exports = __webpack_public_path__ + "img/中国科学技术大学.b7f5358e.png";